import PropTypes from 'prop-types';
import Select from '~/js/components/general/Select';

const SearchPanel = props => {
  const {
    zipCode,
    countries,
    countriesChecked,
    error,
    onSelect,
    onChange,
    onSubmit
  } = props;

  return (
    <div className="search-panel">
      <form className="form" onSubmit={onSubmit}>
        <h3 className="title-4">Enter postal / zip code</h3>

        <div className="field">
          <Select
            data={countries}
            labelKey="name"
            markedKey="id"
            checked={countriesChecked}
            placeholder="Select a Country"
            onChange={onSelect}
          />
          <input
            value={zipCode}
            type="text"
            placeholder="Zip Code"
            className="input"
            onChange={onChange}
          />
          <button className="btn">Go</button>
        </div>

        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
};

SearchPanel.propTypes = {
  zipCode: PropTypes.string,
  countries: PropTypes.array,
  countriesChecked: PropTypes.object,
  onSelect: PropTypes.func
};

SearchPanel.defaultProps = {
  zipCode: '',
  countries: [],
  countriesChecked: {},
  onSelect: () => {},
  onChange: () => {},
  onSubmit: () => {}
};

export default SearchPanel;
